<template>

  <ContentTemplate title="Connections" :container-size-small="true">
    <form>
      <FormGroupSection
          v-for="(item, index) in googleFormInfos"
          :key="index"
          :form-element="item"
          v-model:value="form[item.input.name]"/>
    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';

import useVuelidate from '@vuelidate/core';
import {ContentTemplate, FormGroupSection} from "@shared/components";
import {CommonNs} from "@shared/types";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";

export default defineComponent({
  name: 'ConnectionsView',
  components: {
    ContentTemplate,
    FormGroupSection,
  },
  data() {
    return {
      form: {} as { [key: string]: string },
      googleFormInfos: [] as CommonNs.InputFormGroup[],
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  computed: {
    ...mapStores(useUserStore),
  },
  mounted(): void {
    this.buildForm();
  },
  methods: {
    buildForm(): void {
      this.form = {
        currentEmail: this.userStore.getUserName,
        newEmail: '',
        password: '',
      };
      this.googleFormInfos = [
        {
          label: 'Google Connect',
          iconType: 'fab',
          icon: 'google',
          input: {
            name: 'connectionGoogle',
            type: 'text',
            placeholder: 'Not Connected',
            isDisable: true,
            isLocked: false,
            callbackButton: {
              type: '',
              label: 'Connect Now',
              class: 'btn-google',
              callback: this.redirectToGoogleConnect,
            },
          },
        },
        {
          label: 'Google Connect',
          iconType: 'fab',
          icon: 'google',
          input: {
            name: 'connectionGoogle',
            type: 'text',
            placeholder: 'Connected with md@flexwork.io',
            isDisable: true,
            isLocked: false,
            callbackButton: {
              type: '',
              label: 'Remove',
              class: 'btn-grey',
              callback: this.redirectToGoogleConnect,
            },
          },
        },
      ] as CommonNs.InputFormGroup[];
    },
    redirectToGoogleConnect() {
      this.$router.push({name: ''});
    },
  },
});
</script>

<style lang="scss" scoped>

</style>
